<template>
	<div>
		<h4 class="mb-4 font-weight-bold text-center">Submission Date</h4>
		<div class="date-submission-options mx-auto">
			<b-form-group v-slot="{ ariaDescribedby }">
				<b-form-radio-group
					v-model="innerValue"
					@change="onChange"
					:options="dateOptions"
					:aria-describedby="ariaDescribedby"
					stacked
				></b-form-radio-group>
			</b-form-group>

			<b-row v-if="'custom' === innerValue">
				<b-col>
					<label for="submission-date-from" class="small"
						>Submission Date From</label
					>
					<DatePicker
						v-model="dateFrom"
						format="MM-DD-YYYY"
						value-type="format"
						input-class="form-control form-control-sm"
						:input-attr="{ id: 'report-date-from' }"
						class="w-100 d-block"
					/>
				</b-col>
				<b-col>
					<label for="submission-date-to" class="small"
						>Submission Date To</label
					>
					<DatePicker
						v-model="dateTo"
						:disabled-date="disabledToDates"
						:input-attr="{ id: 'report-date-to' }"
						format="MM-DD-YYYY"
						value-type="format"
						input-class="form-control form-control-sm"
						class="w-100 d-block"
					/>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import "vue2-datepicker/index.css";

import moment from "moment";
import DatePicker from "vue2-datepicker";

export default {
	props: ["value"],
	data() {
		return {
			innerValue: null,
			dateFrom: null,
			dateTo: null,
			dateOptions: [
				{ value: null, text: "All" },
				{ value: "prev-month", text: "Last Month" },
				{ value: "current-month", text: "This Month" },
				{ value: "custom", text: "Custom" },
			],
		};
	},
	components: {
		DatePicker,
	},
	methods: {
		disabledToDates(date, value) {
			return date.getTime() < moment(this.dateFrom, "MMDDYYYY").valueOf();
		},
		onChange(value) {
			const startMonth = moment().startOf("month");
			const endMonth = moment().endOf("month");

			if (null === value) {
				this.$emit("input", null);
			} else if ("prev-month" === value) {
				this.dateFrom = startMonth
					.subtract(1, "month")
					.format("MM-DD-YYYY");
				this.dateTo = endMonth
					.subtract(1, "month")
					.format("MM-DD-YYYY");
			} else if ("current-month" === value) {
				this.dateFrom = startMonth.format("MM-DD-YYYY");
				this.dateTo = endMonth.format("MM-DD-YYYY");
			}
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(newVal) {
				if (!newVal) return false;

				const startMonth = moment().startOf("month");
				const endMonth = moment().endOf("month");

				this.dateFrom = newVal.from;
				this.dateTo = newVal.to;

				if (
					this.dateFrom === startMonth.format("MM-DD-YYYY") &&
					this.dateTo === endMonth.format("MM-DD-YYYY")
				)
					this.innerValue = "current-month";
				else if (
					this.dateFrom ===
						startMonth.subtract(1, "month").format("MM-DD-YYYY") &&
					this.dateTo ===
						endMonth.subtract(1, "month").format("MM-DD-YYYY")
				)
					this.innerValue = "prev-month";
				else this.innerValue = "custom";
			},
		},
		dateFrom(newVal) {
			if (!newVal && !this.dateFrom) return;

			this.$emit("input", {
				from: newVal,
				to: this.dateTo,
			});
		},
		dateTo(newVal) {
			if (!this.dateFrom) return;

			this.$emit("input", {
				from: this.dateFrom,
				to: newVal,
			});
		},
	},
};
</script>

<style lang="scss">
.date-submission-options {
	max-width: 400px;
}
</style>
